import React, { FC } from 'react';
import HyperLink, { ENTITY_TYPE } from '../common/HyperLink';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import WarrantyDisplay from '../common/WarrantyDisplay';
import DateTimeHover from '../date_time_component/DateTime';

const PRWarrantyAssetDetail: FC<any> = ({
	timeZoneId,
	id,
	asset,
	backLinkText,
}): React.ReactElement => {
	return (
		<div className="flex flex-col justify-start">
			<HyperLink
				text={nullSafeGetOrElse('name', asset, `# ${id}`)}
				entityType={ENTITY_TYPE.ASSET_DETAIL}
				entityId={id}
				backLinkText={backLinkText}
			/>
			<div className="mt-2">
				{WarrantyDisplay('Active')}{' '}
				{nullSafeGet('installDate', asset) ? (
					<span className="text-sm text-gray-500">
						from{' '}
						<DateTimeHover
							timestamp={nullSafeGet('installDate', asset)}
							showDate={true}
							showTime={false}
							timeZone={timeZoneId}
						/>
					</span>
				) : null}
			</div>
		</div>
	);
};

export default PRWarrantyAssetDetail;
